
































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";

@Component({
  components: {
    "payouts-history-table": () =>
      import("@/components/app/global/affiliate/payoutsHistoryTable.vue"),
    "payout-destinations-provider": () =>
      import(
        "@/components/app/global/affiliate/payoutDestinationsProvider.vue"
      ),
    "affiliate-payout-destination-form": () =>
      import("@/views/client/account/affiliate/payouts/payoutDestination.vue")
  }
})
export default class ClientAffiliatePayoutsView extends Vue {
  // Inject

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // Props
  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: true })
  public client!: IClient;

  // Computed
  public get affiliateData() {
    return this.$affiliateData();
  }
}
